


















































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import user from '@/store/modules/user';
import ui from '@/store/modules/ui';
import cart from '@/store/modules/cart';
import {err} from '@/commons/toast';
import {RegistrationRequest} from '@/store/models';
import store from '@/store';
import Agreement from '@/components/Cms/Agreement.vue';
import userRegisteredEvent from '@/events/userRegistered';
import redirectToLocation from '@/commons/redirectManager';
import {i18n} from '@/i18n';
import Modal from '@/components/UI/Modal.vue';
import scrollToInput from '@/commons/scrollto';
import {Mutation} from 'vuex-module-decorators';
import HubSpotHiddenFields from '@/components/Checkout/HubSpotHiddenFields.vue';
import {isEmailAvailable} from '@/store/api';
import {availablesSocial, socialPopup} from '@/commons/socialHandler';
import device from '@/store/modules/device';
import handleMessage from '@/commons/messageManager';
import getRecaptchaToken from '@/commons/recaptcha';
import ShowPassword from './ShowPassword.vue';
import Recaptcha from '../Recaptcha.vue';
import app from '@/store/modules/app';
import {isEmpty} from 'lodash';
import {eventSignUp} from '@/commons/gtmhelpers';

@Component({
    components: {
        Agreement,
        Modal,
        HubSpotHiddenFields,
        ShowPassword,
        Recaptcha,
    },
    provide() {
        return {
            $validator: this.$validator,
        };
    },
})
export default class Registration extends Vue {
    public showPassword: boolean = false;
    private loading = false;
    private confirmpassword = '';
    private userData = {
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        pu_gdpr_privacy: '',
        pu_gdpr_profiling: '',
        is_subscribed: '',
    };

    get isIos(){
        return device.isIos;
    }

    private currentStep: number = 0;
    private stepStatus = 'Step {step} of {steps}';

    private showLoginForm() {
        this.$emit('showLoginForm');
    }

    private validatePassword() {
        this.$validator.validate('password');
    }

    private async goToSecondStep() {
        const valid = await this.$validator.validateAll();

        if (!valid) {
            if (this.$validator.errors.items.length > 0) {
                scrollToInput(this.$validator.errors.items[0].field);
            }

            return;
        }

        const isMailAvailable = await isEmailAvailable(this.userData.email);

        if (isMailAvailable) {
            this.setStep(2);
            window.scrollTo(0, 0);
        } else {
            err(
                i18n
                    .t(
                        'There is already an account with this email address. If you are sure that it is your email address, <a href="{url}">click here</a> to get your password and access your account.',
                        {url: `${store.state.options.full_base_url}customer/account/forgotpassword`},
                    )
                    .toString(),
            );
        }
    }

    private goToFirstStep() {
        this.setStep(1);
        window.scrollTo(0, 0);
    }

    private async register(event: Event) {
        const valid = await this.$validator.validateAll();
        let signInToken = '';
        let loginToken = '';

        if (!valid) {
            if (this.$validator.errors.items.length > 0) {
                scrollToInput(this.$validator.errors.items[0].field);
            }

            return;
        }

        if (this.showRegistrationRecaptcha) {
            signInToken = await getRecaptchaToken('sigin');

            if (!signInToken) {
                return;
            }
        }

        if (store.state.options.recaptcha.show_in_customer_login_form) {
            loginToken = await getRecaptchaToken('login');

            if (!loginToken) {
                return;
            }
        }

        this.loading = true;

        const registrationReq = {
            user: {
                firstname: this.userData.firstname,
                lastname: this.userData.lastname,
                email: this.userData.email,
                custom_attributes: [
                    {
                        attribute_code: 'pu_gdpr_privacy',
                        value: +this.userData.pu_gdpr_privacy,
                    },
                    {
                        attribute_code: 'pu_gdpr_profiling',
                        value: +this.userData.pu_gdpr_profiling,
                    },
                ],
                extension_attributes: {
                    is_subscribed: +this.userData.is_subscribed,
                },
                website_id: store.state.options.website_id,
            },
            password: this.userData.password,
            recaptchaToken: signInToken,
        } as RegistrationRequest;

        try {
            const registrationRes = await user.register(registrationReq);
            const userLoginRes = await user.login({
                username: this.userData.email,
                password: this.userData.password,
                cartToken: cart.token,
                recaptchaToken: loginToken,
            });

            handleMessage('success', i18n.t('Registration completed successfully').toString());

            this.$emit('registrationsuccess', userLoginRes);
            this.$eventBus.$emit(userRegisteredEvent, {
                result: registrationRes,
                request: registrationReq,
                userToken: userLoginRes,
                recaptchaToken: loginToken,
            });

            // DataLayer
            eventSignUp('email', this.userData.firstname, this.userData.lastname, this.userData.email);

            redirectToLocation('/checkout/');
        } catch (e) {
            let errmess = i18n.t('Error during registration').toString();

            if (e.response && e.response.data && e.response.data.message) {
                errmess += ` \n ${e.response.data.message}`;
            }

            err(errmess);
            this.loading = false;
        }
    }

    @Mutation
    private setStep(step: number) {
        this.currentStep = step;
    }

    get firstStep() {
        return this.currentStep === 1;
    }

    get secondStep() {
        return this.currentStep === 2;
    }

    get getPrivacyText(): string {
        return store.state.options.register_agreements.privacy.text;
    }

    get getPrivacyLabel(): string {
        return store.state.options.register_agreements.privacy.label;
    }

    get getPrivacyLink(): string {
        return store.state.options.register_agreements.privacy.link;
    }

    get getStepTwoText(): string {
        return store.state.options.register_agreements.step_two.text;
    }

    get getProfilingLabel(): string {
        return store.state.options.register_agreements.profiling.label;
    }

    get getNewsletterLabel(): string {
        return store.state.options.register_agreements.newsletter.label;
    }

    get isApp() {
        return device.isApp;
    }

    get socials() {
        return availablesSocial.socials;
    }

    get socialsEnabled() {
        return !isEmpty(this.socials);
    }

    get showRegistrationRecaptcha() {
        return store.state.options.recaptcha.show_in_customer_create_form;
    }

    private openSocialPopup(social: string, urlSocial: string) {
        if (app.isApp) {
            app.socialLogin(social);
        } else {
            socialPopup(urlSocial);
        }
    }

    private openModal(id: string) {
        ui.openModal(id);
    }

    private closeModal(id: string) {
        ui.closeModal(id);
    }

    private mounted() {
        this.setStep(1);
    }

    private isEnabledIosSocial(social: string) {
        const config = 'app_ios_' + social.toLowerCase();
        return store.state.options.socialAvailables[config]
    }

    private isEnabledAndroidSocial(social: string) {
        const config = 'app_android_' + social.toLowerCase();
        return store.state.options.socialAvailables[config]
    }

    private isEnabledDeviceIosSocial(social: string) {
        const config = 'device_ios_' + social.toLowerCase();
        return store.state.options.socialAvailables[config]
    }
}
